import { NotificationDetailRepairOverview } from "api/resources/models/AutoGenerated";
import { config } from "core/config";


export function onRepairOverviewRowClick(row: NotificationDetailRepairOverview) {
  const env = config.loggingEnvironment;
  let prefix = 'portal';
  if (env === 'dev') {
    prefix = 'dev';
  } else if (env === 'stg') {
    prefix = 'stg';
  }

  if (!row.repairId || !row.repairCode) {
    return;
  }

  const url = `https://${prefix}.activewebonline.com/#/repairs-search/details/${row.repairId}/${row.repairCode}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

